const CartModule = {
  namespaced: true,
  state: {
    data: [],
    dialog: false
  },
  mutations: {
    CLEAR_CART: state => {
      state.data = []
    },
    UPDATE_DIALOG: (state, payload) => {
      state.dialog = payload
    },
    DELETE: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload)
      state.data.splice(index, 1)
    },
    ADD: (state, payload) => {
      state.data.push(payload)
    },
    UPDATE: (state, payload) => {
      state.data = []
      state.data = payload
      // let index = state.data.findIndex(data => data.idx === payload.idx)
      // state.data[index] = payload
    },
    UPDATE_QUANTITY: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload.idx)
      state.data[index].quantity += 1
    }
  },
  actions: {
    delete({ commit }, payload) {
      commit('DELETE', payload)
    },
    update({ commit }, payload) {
      commit('UPDATE', payload)
    },
    addToCart({ commit, state }, payload) {
      let findData = state.data.filter(item => item.idx == payload.idx)
      if (findData.length) {
        commit('UPDATE_QUANTITY', payload)
      } else {
        payload.quantity = 1
        commit('ADD', payload)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    }
  }
}

export default CartModule
